import { render, staticRenderFns } from "./RightTow.vue?vue&type=template&id=b6b86c54"
import script from "./RightTow.vue?vue&type=script&lang=js"
export * from "./RightTow.vue?vue&type=script&lang=js"
import style0 from "./RightTow.vue?vue&type=style&index=0&id=b6b86c54&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports